import React from 'react';
import DateField from '../../../../components/modals/ApplicantFilters/DateField';

interface MeetingDatePickerProps {
  value: Date;
  onChange: (date: Date) => void;
}

const MeetingDatePicker: React.FC<MeetingDatePickerProps> = ({ value, onChange }) => {
  // Set minimum date to today
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <DateField 
      value={value.toISOString()} 
      onChange={(date) => onChange(new Date(date))} 
      minDate={today}
    />
  );
};

export default MeetingDatePicker; 